"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWithIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Button = require("../../Button");
var _Icon = require("../../../Icon/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ButtonWithIcon = exports.ButtonWithIcon = function ButtonWithIcon(_ref) {
  var className = _ref.className,
    content = _ref.content,
    iconFirst = _ref.iconFirst,
    onClick = _ref.onClick,
    styles = _ref.styles,
    Svg = _ref.Svg,
    SvgColor = _ref.SvgColor,
    toggled = _ref.toggled,
    namespace = _ref.namespace,
    qeId = _ref.qeId,
    ariaLabel = _ref.ariaLabel,
    iconHiddenToScreenReader = _ref.iconHiddenToScreenReader,
    collapsed = _ref.collapsed;
  var classNames = (0, _classnames2["default"])(styles.buttonWithIcon, className, _defineProperty({}, styles.toggled, toggled));
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: classNames,
    onClick: onClick,
    namespace: namespace,
    "data-qe-id": qeId,
    "aria-label": ariaLabel,
    "aria-expanded": !collapsed
  }, iconFirst ? /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.buttonContainer
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    Svg: Svg,
    color: SvgColor,
    styles: styles,
    hiddenToScreenReader: iconHiddenToScreenReader
  }), /*#__PURE__*/_react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: content
    },
    className: styles.content
  })) : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: content
    },
    className: styles.content
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    Svg: Svg,
    color: SvgColor,
    styles: styles
  })));
};
ButtonWithIcon.propTypes = {
  className: _propTypes["default"].string,
  content: _propTypes["default"].string.isRequired,
  iconFirst: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  Svg: _propTypes["default"].func.isRequired,
  SvgColor: _propTypes["default"].string,
  toggled: _propTypes["default"].bool,
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  iconHiddenToScreenReader: _propTypes["default"].bool,
  collapsed: _propTypes["default"].bool
};
ButtonWithIcon.defaultProps = {
  className: '',
  iconFirst: true,
  onClick: undefined,
  styles: {},
  SvgColor: '#000000',
  toggled: false,
  namespace: '',
  qeId: undefined,
  ariaLabel: 'Open/close toggle',
  iconHiddenToScreenReader: false,
  collapsed: false
};